import { NgModule } from "@angular/core";
import { providerUpgradeFactory } from "@webapp/core/provider-upgrade/factories/provider-upgrade.factory";

@NgModule({
  imports: [],
  providers: [
    {
      provide: "$rootScope",
      useFactory: providerUpgradeFactory("$rootScope"),
      deps: ["$injector"],
    },
  ],
})
export class UsersModule {}
